import React from 'react'
import Item from '../Funnel/Item'

export default function FunnelRoute() {
  return (
    <Item slug='test' />
  )
}
